import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import groupedUnits from './units';

interface IDatasetUnitSelectorProps {
    className: string;
    value: string;
    onChange: (e: string) => void;
}

const DatasetUnitSelector = ({ className, value, onChange }: IDatasetUnitSelectorProps) => {

    return <Dropdown
        className={className}
        value={value}
        onChange={(e) => onChange(e.value)}
        options={groupedUnits}
        optionLabel='label'
        optionGroupLabel='label'
        optionGroupChildren='items'
        filter
        editable />;
};

export default DatasetUnitSelector;
